import React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '../../../../../components/Header'
import { SearchField } from '../../../../../components/SearchField'

type Props = {
  globalFilterValue: string
  setGlobalFilterValue: (value: string) => void
}

export const Title: React.FC<Props> = ({
  globalFilterValue,
  setGlobalFilterValue,
}) => {
  const { t } = useTranslation()

  const actions = (
    <SearchField
      searchValue={globalFilterValue}
      setSearchValue={setGlobalFilterValue}
      placeholder={t('members.title.search.placeholder')}
    />
  )
  return <Header title={t('members.title.title')} actions={actions} />
}
